// Icon.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const IconPlus = ({ icon = faPlus, size = '3x', color = '#f5721e' }) => {
  return <FontAwesomeIcon icon={icon} size={size} color={color} />;
};

export default IconPlus;
